import { usePeriodoGestacionalQuery } from 'graphql/hooks.generated'
import { dateAsYyyyMmDd, toDate } from 'util/date/formatDate'

import { ResultadosExamesModel } from '../../../objetivo/resultados-exames/model-resultadosExames'
import {
  filterResultadosExamesAndConvertToExamePreNatalInput,
  isResultadoExamePreNatal,
} from '../../../objetivo/resultados-exames/util-resultadosExames'
import { convertPeriodoGestacionalToIdadeGestacional } from '../converter-acompanhamentoPreNatal'
import { IdadeGestacionalAcompanhamentoPreNatal, PeriodoGestacionalQueryModel } from '../model-acompanhamentoPreNatal'

interface UsePeriodoGestacionalProps {
  prontuarioId?: string
  dum: Date
  dumAtendimentoAtual?: Date
  dataAtendimento: Date | number
  resultadosExamesAtendimentoAtual?: ResultadosExamesModel
  skip?: boolean
}

export interface UsePeriodoGestacionalResult
  extends Omit<
    PeriodoGestacionalQueryModel,
    'idadeGestacional' | 'isEcografico' | 'dataInicioGestacao' | 'dataProvavelPartoEcografica'
  > {
  dataInicioGestacao: Date
  dataProvavelPartoEcografica?: Date
  idadeGestacional: IdadeGestacionalAcompanhamentoPreNatal
  loading: boolean
}

export function usePeriodoGestacional({
  prontuarioId,
  dum,
  dumAtendimentoAtual,
  dataAtendimento,
  resultadosExamesAtendimentoAtual,
  skip,
}: UsePeriodoGestacionalProps): UsePeriodoGestacionalResult {
  const resultadosExamesPreNatalAsInput =
    resultadosExamesAtendimentoAtual &&
    filterResultadosExamesAndConvertToExamePreNatalInput(resultadosExamesAtendimentoAtual, isResultadoExamePreNatal)

  const { data, loading } = usePeriodoGestacionalQuery({
    skip: !prontuarioId || !dum || !dataAtendimento || skip,
    variables: {
      input: {
        prontuarioId,
        dum,
        dumAtendimentoAtual,
        dataAtendimento: dateAsYyyyMmDd(dataAtendimento),
        resultadosExamesPreNatalAtendimentoAtual: resultadosExamesPreNatalAsInput,
      },
    },
  })

  const periodoGestacional = data?.periodoGestacional

  return {
    ...periodoGestacional,
    dataInicioGestacao: toDate(periodoGestacional?.dataInicioGestacao),
    dataProvavelPartoEcografica: toDate(periodoGestacional?.dataProvavelPartoEcografica),
    idadeGestacional: convertPeriodoGestacionalToIdadeGestacional(periodoGestacional),
    loading,
  }
}
